import { CLEAR_AUDIT_INFO, SET_AUDIT_INFO } from "../types";

const INITIAL_STATE = {
    reportData: []
};

/**
 * Extrae defensivamente un arreglo de datos desde el payload de respuesta de la API.
 * Soporta respuestas en forma de arreglo directo o propiedades comunes de envoltura.
 */
const extractDataDefensively = (payload) => {
    if (!payload) return [];
    
    // Si el payload es directamente un arreglo
    if (Array.isArray(payload)) {
        return payload;
    }
    
    // Probar las claves comunes esperadas de la respuesta
    const keysToTry = ['reportData', 'data', 'items', 'rows', 'report'];
    for (const key of keysToTry) {
        if (payload[key] && Array.isArray(payload[key])) {
            return payload[key];
        }
    }
    
    // Recorrer el objeto buscando cualquier propiedad que sea un arreglo
    for (const key in payload) {
        if (Object.prototype.hasOwnProperty.call(payload, key) && Array.isArray(payload[key])) {
            return payload[key];
        }
    }
    
    return [];
};

const auditReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_AUDIT_INFO:
            return {
                ...state,
                reportData: extractDataDefensively(action.payload)
            };
        case CLEAR_AUDIT_INFO:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export default auditReducer;
